import React, { Component } from 'react';
import PropTypes from 'prop-types';

class TwitterFollowButton extends Component {
  static propTypes = {
    userId: PropTypes.string,
  };

  static defaultProps = {
    userId: 'DorMoshe',
  };

  componentDidMount() {
    try {
      if (window.twttr) {
        window.twttr.widgets.load().then(() => {
          this._createFollowButton();
        });

        return;
      }
      
      this._createFollowButton();
    }
    catch(err){}
  }

  _createFollowButton() {
    try {
      if (this._buttonRef && window.twttr && this.props.userId) {
        window.twttr.widgets.createFollowButton(this.props.userId, this._buttonRef, { 
          size: 'large'
        });
      }
    }
    catch(err){}
  }  

  _setButtonRef = (ref) => {
    this._buttonRef = ref;
  }

  render() {
    return (
      <div ref={this._setButtonRef}></div>
    );
  }
};

export default TwitterFollowButton;